import React from 'react';
import CreateTenant from 'pages/Tenants/CreateTenant';
import UpdateTenantConfig from 'pages/Tenants/UpdateTenantConfig';
import { useTenantsContext } from 'pages/Tenants/tenants.context';
import TenantsFilter from 'pages/Tenants/Table/Filters';
import EmptyData from 'components/Messages/EmptyData/EmptyData';
import OverviewTable from 'components/Table/Table';
import { IconBox } from 'components/StyledComponents/IconBox';
import { TableColumnInterface } from 'components/Table/table.types';
import { Tenant } from '@restore/services-lib';

const TenantsTable = (): JSX.Element => {
  const { tenants } = useTenantsContext();

  const tableCols: TableColumnInterface<Tenant>[] = [
    { label: 'ID', value: (tenant) => tenant.id },
    { label: 'Name', value: (tenant) => tenant.name, sortBy: 'name' },
    {
      label: '',
      align: 'right',
      value: (tenant) => {
        return (
          <IconBox>
            <UpdateTenantConfig tenant={tenant} />
            {/* <UpdateTenant tenant={tenant} /> TODO: conditionally render this based on user permissions */}
          </IconBox>
        );
      },
    },
  ];

  return (
    <>
      <TenantsFilter />
      <OverviewTable
        data={tenants}
        columns={tableCols}
        noDataMessageOverride={<EmptyData dataType='tenant' action={<CreateTenant />} />}
      />
    </>
  );
};

export default TenantsTable;
